// extracted by mini-css-extract-plugin
export default {"block":"aGbA1s"};